import "bootstrap/dist/css/bootstrap.min.css";
import { get, onValue, push, ref, remove, update } from "firebase/database";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import WorkMasterHeader from "./WorkMasterHeader";

const WorkMaster = () => {
  const [workTypes, setWorkTypes] = useState([]);
  const [workAreas, setWorkAreas] = useState([]);
  const [mandirs, setMandirs] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [type, setType] = useState("");
  const [selectedWorkType, setSelectedWorkType] = useState("");
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("workTypes");

  // Mandir form fields
  const [mNickName, setMNickName] = useState('');
  const [mFullName, setMFullName] = useState('');
  const [mAddress, setMAddress] = useState('');
  const [mRemark, setMRemark] = useState('');
  const [mState, setMState] = useState('');
  const [mCity, setMCity] = useState('');
  const [mandirFilter, setMandirFilter] = useState('all'); // all | pending | approved

  useEffect(() => {
    const fetchData = (path, setter) =>
      onValue(ref(db, path), snap =>
        setter(snap.exists() ? Object.entries(snap.val()).map(([id, v]) => ({ id, ...v })) : [])
      );
    fetchData("masters/workTypes", setWorkTypes);
    fetchData("masters/workAreas", setWorkAreas);
    fetchData("masters/jainMandir", setMandirs);
    fetchData("masters/states", setStates);
    fetchData("masters/cities", setCities);
  }, []);

  const exists = (list, condition) =>
    list.some(item => Object.keys(condition).every(k => item[k] === condition[k]));

  const resetForm = () => { setEditId(null); setSelectedWorkType(""); setName(""); };
  const resetMandirForm = () => { setMNickName(''); setMFullName(''); setMAddress(''); setMRemark(''); setMState(''); setMCity(''); setEditId(null); };

  const openModal = (t, row = null) => {
    setType(t);
    resetForm();
    if (row) { setEditId(row.id); setSelectedWorkType(row.workType || ""); setName(row.name || ""); }
    setShowModal(true);
  };

  const openMandirModal = (row = null) => {
    setType('mandir');
    resetMandirForm();
    if (row) {
      setEditId(row.id);
      setMNickName(row.nickName || '');
      setMFullName(row.fullName || '');
      setMAddress(row.address || '');
      setMRemark(row.remark || '');
      setMState(row.state || '');
      setMCity(row.district || '');
    }
    setShowModal(true);
  };

  const handleDelete = async (itemId, itemType) => {
    if (!window.confirm('क्या आप वाकई इस आइटम को हटाना चाहते हैं?')) return;
    setLoading(true);
    try {
      const pathMap = { workType: 'masters/workTypes', workArea: 'masters/workAreas', mandir: 'masters/jainMandir' };
      await remove(ref(db, `${pathMap[itemType]}/${itemId}`));
      alert('आइटम सफलतापूर्वक हटा दिया गया ✅');
    } catch (error) { alert(`त्रुटि: ${error.message}`); }
    finally { setLoading(false); }
  };

  const handleApproveMandir = async (id) => {
    try {
      await update(ref(db, `masters/jainMandir/${id}`), { pendingApproval: false });
      alert('मंदिर स्वीकृत कर दिया गया ✅');
    } catch { alert('त्रुटि हुई ❌'); }
  };

  const handleSave = async () => {
    if (type === 'mandir') {
      if (!mNickName.trim() || !mState || !mCity) return alert('नाम, राज्य और शहर आवश्यक हैं');
      setLoading(true);
      try {
        const formData = { nickName: mNickName.trim(), fullName: mFullName.trim(), address: mAddress.trim(), remark: mRemark.trim(), state: mState, district: mCity };
        if (editId) {
          const existing = mandirs.find(m => m.id === editId);
          const { id: _id, ...existingFields } = existing || {};
          await update(ref(db, `masters/jainMandir/${editId}`), { ...existingFields, ...formData });
          // Cascade: update all registrations that stored the old nickName
          if (existing.nickName !== mNickName.trim()) {
            const snap = await get(ref(db, "registration"));
            if (snap.exists()) {
              const updates = {};
              Object.entries(snap.val()).forEach(([regId, reg]) => {
                if (reg.basic?.Mandirtype === existing.nickName)
                  updates[`registration/${regId}/basic/Mandirtype`] = mNickName.trim();
              });
              if (Object.keys(updates).length > 0) await update(ref(db), updates);
            }
          }
        } else {
          await push(ref(db, 'masters/jainMandir'), { ...formData, pendingApproval: false });
        }
        resetMandirForm(); setShowModal(false);
        alert('सफलतापूर्वक सेव किया गया ✅');
      } catch { alert('सेव करने में त्रुटि हुई ❌'); }
      finally { setLoading(false); }
      return;
    }

    if (!name.trim()) return alert("नाम आवश्यक है");
    setLoading(true);
    try {
      if (type === "workType") {
        if (!editId && exists(workTypes, { name })) return alert("यह कार्य प्रकार पहले से मौजूद है");
        const data = { name: name.trim() };
        editId ? await update(ref(db, `masters/workTypes/${editId}`), data) : await push(ref(db, "masters/workTypes"), data);
      }
      if (type === "workArea") {
        if (!selectedWorkType) return alert("कार्य प्रकार चुनें");
        if (!editId && exists(workAreas, { workType: selectedWorkType, name })) return alert("यह कार्य क्षेत्र पहले से मौजूद है");
        const data = { workType: selectedWorkType, name: name.trim() };
        editId ? await update(ref(db, `masters/workAreas/${editId}`), data) : await push(ref(db, "masters/workAreas"), data);
      }
      resetForm(); setShowModal(false);
      alert('सफलतापूर्वक सेव किया गया ✅');
    } catch { alert("सेव करने में त्रुटि हुई ❌"); }
    finally { setLoading(false); }
  };

  const pendingCount = mandirs.filter(m => m.pendingApproval === true).length;
  const filteredMandirs = mandirs.filter(m =>
    mandirFilter === 'all' ? true : mandirFilter === 'pending' ? m.pendingApproval === true : m.pendingApproval !== true
  );

  return (
    <div className="container mt-4">
      <WorkMasterHeader />

      <ul className="nav nav-tabs mb-4" role="tablist">
        <li className="nav-item"><button className={`nav-link ${activeTab === "workTypes" ? "active" : ""}`} onClick={() => setActiveTab("workTypes")}>कार्य का प्रकार ({workTypes.length})</button></li>
        <li className="nav-item"><button className={`nav-link ${activeTab === "workAreas" ? "active" : ""}`} onClick={() => setActiveTab("workAreas")}>कार्य का क्षेत्र ({workAreas.length})</button></li>
        <li className="nav-item">
          <button className={`nav-link ${activeTab === "mandirs" ? "active" : ""}`} onClick={() => setActiveTab("mandirs")}>
            🕌 जैन मंदिर ({mandirs.length})
            {pendingCount > 0 && <span className="badge bg-warning text-dark ms-1">{pendingCount} pending</span>}
          </button>
        </li>
      </ul>

      {/* Work Types Tab */}
      {activeTab === "workTypes" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>कार्य का प्रकार <span className="badge bg-info ms-2">कुल: {workTypes.length}</span></h5>
            <button className="btn btn-sm btn-success" onClick={() => openModal("workType")}>+ कार्य प्रकार जोड़ें</button>
          </div>
          <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark"><tr><th>क्रम</th><th>कार्य प्रकार का नाम</th><th>Actions</th></tr></thead>
            <tbody>
              {workTypes.length === 0 ? <tr><td colSpan={3} className="text-center text-muted">कोई डेटा नहीं मिला</td></tr> :
                workTypes.map((row, idx) => (
                  <tr key={row.id}>
                    <td className="text-center">{idx + 1}</td>
                    <td>{row.name || "-"}</td>
                    <td><div className="d-flex gap-1">
                      <button className="btn btn-sm btn-warning" onClick={() => openModal("workType", row)}>✏️ Edit</button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.id, "workType")}>🗑️ Delete</button>
                    </div></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Work Areas Tab */}
      {activeTab === "workAreas" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h5>कार्य का क्षेत्र <span className="badge bg-info ms-2">कुल: {workAreas.length}</span></h5>
            <button className="btn btn-sm btn-success" onClick={() => openModal("workArea")}>+ कार्य क्षेत्र जोड़ें</button>
          </div>
          <table className="table table-bordered table-striped table-sm">
            <thead className="table-dark"><tr><th>क्रम</th><th>कार्य प्रकार</th><th>कार्य क्षेत्र का नाम</th><th>Actions</th></tr></thead>
            <tbody>
              {workAreas.length === 0 ? <tr><td colSpan={4} className="text-center text-muted">कोई डेटा नहीं मिला</td></tr> :
                workAreas.map((row, idx) => (
                  <tr key={row.id}>
                    <td className="text-center">{idx + 1}</td>
                    <td>{row.workType || "-"}</td>
                    <td>{row.name || "-"}</td>
                    <td><div className="d-flex gap-1">
                      <button className="btn btn-sm btn-warning" onClick={() => openModal("workArea", row)}>✏️ Edit</button>
                      <button className="btn btn-sm btn-danger" onClick={() => handleDelete(row.id, "workArea")}>🗑️ Delete</button>
                    </div></td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Jain Mandir Tab */}
      {activeTab === "mandirs" && (
        <div className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <h5>🕌 जैन मंदिर <span className="badge bg-info ms-2">कुल: {mandirs.length}</span>{pendingCount > 0 && <span className="badge bg-warning text-dark ms-1">{pendingCount} स्वीकृति प्रतीक्षित</span>}</h5>
            <div className="d-flex gap-2">
              <select className="form-select form-select-sm" value={mandirFilter} onChange={e => setMandirFilter(e.target.value)} style={{ width: 'auto' }}>
                <option value="all">सभी ({mandirs.length})</option>
                <option value="pending">⏳ प्रतीक्षित ({pendingCount})</option>
                <option value="approved">✅ स्वीकृत ({mandirs.length - pendingCount})</option>
              </select>
              <button className="btn btn-sm btn-success" onClick={() => openMandirModal()}>+ मंदिर जोड़ें</button>
            </div>
          </div>

          {pendingCount > 0 && mandirFilter !== 'approved' && (
            <div className="alert alert-warning py-2 mb-3">
              ⚠️ <strong>{pendingCount} मंदिर</strong> उपयोगकर्ता द्वारा जोड़े गए हैं और स्वीकृति की प्रतीक्षा में हैं। कृपया समीक्षा करें।
            </div>
          )}

          <div className="table-responsive">
            <table className="table table-bordered table-sm">
              <thead className="table-dark">
                <tr><th>#</th><th>Nick Name</th><th>पूरा नाम</th><th>राज्य</th><th>शहर</th><th>पता</th><th>स्थिति</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {filteredMandirs.length === 0 ? <tr><td colSpan={8} className="text-center text-muted">कोई डेटा नहीं</td></tr> :
                  filteredMandirs.map((row, idx) => (
                    <tr key={row.id} style={row.pendingApproval ? { background: '#fff3cd' } : {}}>
                      <td>{idx + 1}</td>
                      <td className="fw-semibold">
                        {row.nickName || '-'}
                        {row.pendingApproval === true && <span className="badge bg-warning text-dark ms-1" style={{ fontSize: '0.7rem' }}>⏳ Pending</span>}
                      </td>
                      <td>{row.fullName || '-'}</td>
                      <td>{row.state || '-'}</td>
                      <td>{row.district || '-'}</td>
                      <td style={{ maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{row.address || '-'}</td>
                      <td>
                        {row.pendingApproval === true
                          ? <span className="badge bg-warning text-dark">⏳ प्रतीक्षित</span>
                          : <span className="badge bg-success">✅ स्वीकृत</span>}
                      </td>
                      <td>
                        <div className="d-flex gap-1 flex-wrap">
                          {row.pendingApproval === true && (
                            <button className="btn btn-xs btn-success px-2 py-1" style={{ fontSize: '0.75rem' }} onClick={() => handleApproveMandir(row.id)}>✅ Approve</button>
                          )}
                          <button className="btn btn-xs btn-warning px-2 py-1" style={{ fontSize: '0.75rem' }} onClick={() => openMandirModal(row)}>✏️ Edit</button>
                          <button className="btn btn-xs btn-danger px-2 py-1" style={{ fontSize: '0.75rem' }} onClick={() => handleDelete(row.id, 'mandir')}>🗑️ Delete</button>
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div className="modal d-block" tabIndex={-1} style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {type === 'mandir' && (editId ? 'मंदिर संपादित करें' : 'मंदिर जोड़ें')}
                  {type === 'workType' && (editId ? 'कार्य प्रकार संपादित करें' : 'कार्य प्रकार जोड़ें')}
                  {type === 'workArea' && (editId ? 'कार्य क्षेत्र संपादित करें' : 'कार्य क्षेत्र जोड़ें')}
                </h5>
                <button type="button" className="btn-close" onClick={() => setShowModal(false)} disabled={loading}></button>
              </div>
              <div className="modal-body">
                {type === 'mandir' && (
                  <div className="row g-3">
                    <div className="col-12 col-md-6"><label className="form-label fw-semibold">Nick Name *</label><input className="form-control" value={mNickName} onChange={e => setMNickName(e.target.value)} placeholder="जैसे: शांतिनाथ मंदिर" /></div>
                    <div className="col-12 col-md-6"><label className="form-label fw-semibold">पूरा नाम</label><input className="form-control" value={mFullName} onChange={e => setMFullName(e.target.value)} /></div>
                    <div className="col-12 col-md-6"><label className="form-label fw-semibold">राज्य *</label>
                      <select className="form-select" value={mState} onChange={e => { setMState(e.target.value); setMCity(''); }}>
                        <option value="">चुनें</option>{states.map(s => <option key={s.id} value={s.name}>{s.name}</option>)}
                      </select>
                    </div>
                    <div className="col-12 col-md-6"><label className="form-label fw-semibold">शहर *</label>
                      <select className="form-select" value={mCity} onChange={e => setMCity(e.target.value)} disabled={!mState}>
                        <option value="">चुनें</option>{cities.filter(c => c.state === mState).map(c => <option key={c.id} value={c.name}>{c.name}</option>)}
                      </select>
                    </div>
                    <div className="col-12"><label className="form-label fw-semibold">पता</label><input className="form-control" value={mAddress} onChange={e => setMAddress(e.target.value)} /></div>
                    <div className="col-12"><label className="form-label fw-semibold">विशेष टिप्पणी</label><input className="form-control" value={mRemark} onChange={e => setMRemark(e.target.value)} /></div>
                  </div>
                )}
                {type === 'workType' && (
                  <div className="mb-3"><label className="form-label">कार्य प्रकार का नाम *</label><input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} disabled={loading} /></div>
                )}
                {type === 'workArea' && (
                  <>
                    <div className="mb-3"><label className="form-label">कार्य प्रकार चुनें *</label>
                      <select className="form-select" value={selectedWorkType} onChange={e => setSelectedWorkType(e.target.value)} disabled={loading}>
                        <option value="">-- कार्य प्रकार चुनें --</option>{workTypes.map(w => <option key={w.id} value={w.name}>{w.name}</option>)}
                      </select>
                    </div>
                    <div className="mb-3"><label className="form-label">कार्य क्षेत्र का नाम *</label><input type="text" className="form-control" value={name} onChange={e => setName(e.target.value)} disabled={loading} /></div>
                  </>
                )}
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)} disabled={loading}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleSave} disabled={loading}>{loading ? 'सेव कर रहे हैं...' : editId ? 'Update' : 'Save'}</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WorkMaster;